import { useNavigate, useParams } from 'react-router';

import { ChallengesMainIcon, PrototypesIcon } from '@app-velocity/icons';
import { useI18n } from '@app-velocity/i18n';

import { ScenarioRoutePaths } from '@app-velocity/modules/scenarios';

import { useCurrentTeamPermissions } from '@app-velocity/libs/team-permissions';

import { Button } from '@app-velocity/ui';

import { MessageBus } from '@app-velocity/message-bus';

import { HomeCard } from '../HomeCard';
import { WhereToStartLinks } from '../WhereToStartLinks/WhereToStartLinks';

const teamsMessageBus = new MessageBus('teams');

export type CreateAChallengeCardProps = {
  mode: 'authorized' | 'guest';
  withLinks?: boolean;
};

export const CreateAChallengeCard = ({
  mode,
  withLinks,
}: CreateAChallengeCardProps) => {
  const { t } = useI18n();
  const currentTeam = useCurrentTeamPermissions();
  const { workspaceId, teamId } = useParams<{
    teamId?: string;
    workspaceId?: string;
  }>();
  const navigate = useNavigate();

  const goToNewScenario = () => {
    if (mode === 'authorized') {
      if (!workspaceId || !teamId) return;
      if (!currentTeam) return;

      const higherTieredTeam = currentTeam.getHigherTieredTeam();

      if (higherTieredTeam) {
        teamsMessageBus.publish('modal:paid-team-available:open', {
          team: higherTieredTeam,
          redirectToSelectFlow: true,
          onModalCloseCallback: () => {
            navigate(ScenarioRoutePaths.challengeAFlow(teamId!, workspaceId!));
          },
        });

        return;
      }

      if (!currentTeam.canRunSimulations(1)) {
        return;
      }

      navigate(ScenarioRoutePaths.challengeAFlow(teamId, workspaceId));
    } else {
      navigate(ScenarioRoutePaths.challengeAFlowAsAGuest());
    }
  };

  const challengesButtonId = `challenge_flow_button${
    mode === 'guest' ? '_guest' : ''
  }`;

  return (
    <HomeCard
      variant="primary"
      icon={<ChallengesMainIcon />}
      text="prototypes:card_text"
      action={
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={goToNewScenario}
          data-ph-capture-attribute-id={challengesButtonId}
        >
          {t('prototypes:challenge_a_flow')}
          <PrototypesIcon />
        </Button>
      }
      additionalAction={withLinks ? <WhereToStartLinks /> : null}
    />
  );
};
